module.exports = __webpack_public_path__ + "static/media/article01.f36405e8.pdf";